import React, { ChangeEvent, memo, useCallback, useState } from 'react';
import { Container, Label } from './style';
import { Input as InputBase } from '@chakra-ui/core';
import { IPaginationParams } from 'src/models/interfaces/pagination';

interface IProps {
  paginationParams: IPaginationParams;
  onChange: (params: { term: string; page: number }) => void;
  label: string;
  placeholder?: string;
  width?: string;
}

const SearchField = memo(({ paginationParams, onChange, label, width, ...props }: IProps) => {
  const [searchTerm, setSearchTerm] = useState(paginationParams.term ?? '');

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.currentTarget.value ?? '';
      setSearchTerm(value);

      if (value?.length > 2) {
        onChange({ term: value, page: 0 });
        return;
      }

      if (paginationParams.term) {
        onChange({ term: '', page: 0 });
      }
    },
    [onChange, paginationParams.term]
  );

  return (
    <Container style={{ width: width }}>
      <Label>{label}</Label>
      <InputBase
        {...props}
        color="#333 !important"
        borderColor='#01509C'
        borderRadius='6px'
        height='36px'
        fontSize={14}
        onChange={handleChange}
        value={searchTerm}
      />
    </Container>
  );
});

export default SearchField;
